/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import React from 'react';
import darkImage from 'images/main/viewpost-app-logo-grey.svg?url';
import lightImage from 'images/main/viewpost-app-logo.svg?url';
import blueImage from 'images/main/viewpost.svg?url';
import vpImage from 'images/main/vp-id.svg?url';

export const Logo = ({
  className,
  height = '26',
  width = '125',
  variant = 'light'
}) => {
  let image = lightImage;
  let imgWidth = width;
  let imgHeight = height;
  switch (variant) {
    case 'dark':
      image = darkImage;
      break;
    case 'blue':
      image = blueImage;
      break;
    case 'vp':
      image = vpImage;
      imgWidth = 50;
      imgHeight = 18;
      break;
    default:
      break;
  }
  return (
    <img className={className}
      src={image}
      height={imgHeight}
      width={imgWidth}
      style={{borderStyle: 'none'}}
      alt="Viewpost Logo" />
  );
};

export default Logo;
